import { useState } from "react";
import ErrorAction from "../../components/Modal/ErrorAction";
import env, { normalPriceCount, payValue, normalPriceRound } from "../../env";
import DataModal from "../../components/Modal/dataModal";
import QuickOff from "./QuickOff";
import QuickCounter from "./QuickCounter";
import FormattedInputs from "../../components/Button/FormattedInputs";
import PostReq from "../../utils/PostReq";
function QuickRow(props) {
  const data = props.data;
  const token = props.token;
  const user = props.user;
  const tab = props.tab;
  const [showDesc, setShowDesc] = useState(0);
  const [editMode, setEditMode] = useState(0);
  const [changes, setChanges] = useState();
  const [showRemove, setShowRemove] = useState();
  const [Weight, setWeight] = useState("");
  const [Ayar, setAyar] = useState("");
  const [Total, setTotal] = useState("");
  const updateField = (Description) => {
    const postOptions = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
      body: JSON.stringify({
        userId: user._id,
        price: changes?.Total,
        weight: changes?.Weight,
        ayar: changes?.Ayar,
        count: changes?.Count,
        id: data._id,
        ...Description,
      }),
    };
    console.log(postOptions);
    fetch(env.siteApi + "/panel/cart/update-cart", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.error) {
            props.setError({ message: result.error, color: "brown" });
            setTimeout(
              () => props.setError({ message: "", color: "brown" }),
              3000
            );
          } else {
            props.setCart(result);
            props.setError({ message: result.message, color: "orange" });
            setTimeout(
              () => props.setError({ message: "", color: "brown" }),
              3000
            );
            setEditMode(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const updateDesc = async (description) => {
    const result = await PostReq({
      method: "Post",
      url: "/panel/cart/update-desc",
      body: { id: data._id, description },
    });
    props.setCart(result);
    setEditMode(false);
  };
  // const updateDesc = (description) => {
  //   const postOptions = {
  //     method: "post",
  //     headers: {
  //       "Content-Type": "application/json",
  //       "x-access-token": token && token.token,
  //       userId: token && token.userId,
  //     },
  //     body: JSON.stringify({
  //       id: data._id,
  //       description,
  //     }),
  //   };
  //   console.log(postOptions);
  //   fetch(env.siteApi + "/panel/cart/update-desc", postOptions)
  //     .then((res) => res.json())
  //     .then(
  //       (result) => {
  //         if (result.error) {
  //           props.setError({ message: result.error, color: "brown" });
  //           setTimeout(
  //             () => props.setError({ message: "", color: "brown" }),
  //             3000
  //           );
  //         } else {
  //           props.setCart(result);
  //           props.setError({ message: result.message, color: "orange" });
  //           setTimeout(
  //             () => props.setError({ message: "", color: "brown" }),
  //             3000
  //           );
  //           setEditMode(false);
  //         }
  //       },
  //       (error) => {
  //         console.log(error);
  //       }
  //     );
  // };

  const removeItem = () => {
    const postOptions = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
      body: JSON.stringify({
        userId: user._id,
        id: data._id,
      }),
    };
    console.log(postOptions);
    fetch(env.siteApi + "/panel/cart/remove-cart", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.error) {
            props.setError({ message: result.error, color: "brown" });
            setTimeout(
              () => props.setError({ message: "", color: "brown" }),
              3000
            );
          } else {
            props.setCart(result);
            props.setError({ message: result.message, color: "orange" });
            setTimeout(
              () => props.setError({ message: "", color: "brown" }),
              3000
            );
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const defAction = () => {
    props.action({ cartID: data.id });
  };
  const saveChanges = () => {
    updateField(changes);
    console.log(changes);
    setEditMode(0);
  };
  return (
    <>
      <tr className={`product-tr ${data.purchase ? "purchase-tr" : ""}`}>
        <td data-cell="ردیف">
          <p>{props.index}</p>
        </td>

        <td className="long-td">
          <p className="name">{data.title}</p>
        </td>
        <td data-cell="کد کالا">
          {data.purchase ? <p>خرید</p> : <p>{data.sku}</p>}
        </td>
        {data.count ? (
          <td data-cell="تعداد">
            {editMode ? (
              <div className="code-input-wrapper new-input">
                <input
                  className="dp-input"
                  type="number"
                  placeholder="تعداد"
                  onChange={(e) =>
                    setChanges((prevState) => ({
                      ...prevState,
                      Count: e.target.value,
                    }))
                  }
                />
              </div>
            ) : (
              <p>{data.count}</p>
            )}
          </td>
        ) : (
          <></>
        )}
        <td data-cell="وزن">
          {editMode && !data.isCoin ? (
            <div className="code-input-wrapper new-input">
              <input
                className="dp-input"
                type="number"
                placeholder="وزن"
                onChange={(e) =>
                  setChanges((prevState) => ({
                    ...prevState,
                    Weight: e.target.value,
                  }))
                }
              />
            </div>
          ) : (
            <p>{data.weight + "g"}</p>
          )}
        </td>
        <td data-cell="عیار">
          {editMode && !data.isCoin ? (
            <div className="code-input-wrapper new-input">
              <input
                className="dp-input"
                type="number"
                placeholder="عیار"
                onChange={(e) =>
                  setChanges((prevState) => ({
                    ...prevState,
                    Ayar: e.target.value,
                  }))
                }
              />
            </div>
          ) : (
            <p>{data && data.ayar}</p>
          )}
        </td>
        {data.lab ? (
          <td data-cell="آزمایشگاه">
            <p>{data.lab}</p>
          </td>
        ) : (
          <></>
        )}
        {data.riang ? (
          <td data-cell="ری انگ">
            <p>{data.riang}</p>
          </td>
        ) : (
          <></>
        )}
        <td data-cell="مبلغ واحد">
          <p>{normalPriceCount(data.unitPrice)}</p>
        </td>
        {data.purchase ? (
          <></>
        ) : (
          <td data-cell="مبلغ به ازای هر گرم">
            <p>
              {normalPriceCount(data.priceDetail && data.priceDetail.unitGold)}
            </p>
          </td>
        )}

        <td
          data-cell="مبلغ کل"
          className={!data.count && data.purchase ? "long-td" : ""}
        >
          {editMode ? (
            <div className="code-input-wrapper new-input">
              <FormattedInputs
                setSendBank={setChanges}
                SendBank={changes}
                type={"Total"}
              />
            </div>
          ) : (
            <p>{normalPriceCount(data.fullPrice)}</p>
          )}
        </td>
        <td className="long-td">
          {editMode ? (
            <div className="more-btn">
              <i className="fa-solid fa-save" onClick={updateField}></i>
              <i
                className="fa-solid fa-remove"
                onClick={() => setEditMode(0)}
              ></i>
            </div>
          ) : (
            <div className="more-btn">
              {!data.isShemsh && props.canEdit ? (
                <i
                  className="fa-solid fa-pen"
                  onClick={() => setEditMode(1)}
                ></i>
              ) : (
                <></>
              )}
              <i
                className="fa-solid fa-comment"
                onClick={() => setShowDesc(1)}
              ></i>
              {/* {data.stock?<i className="fa-solid fa-sign-out storeSelect"
                onClick={()=>updateField({stock:""})}></i>:
                <i className="fa-solid fa-sign-out"
                    onClick={()=>updateField({stock:"9"})}></i>} */}
              <i
                className="fa-solid fa-trash"
                style={{ color: "red" }}
                onClick={() => setShowRemove(1)}
              ></i>
            </div>
          )}
        </td>
      </tr>
      {showRemove ? (
        <ErrorAction
          status={"DELETE"}
          title={"حذف آیتم"}
          text={"آیتم انتخاب شده حذف خواهد شد. آیا مطمئن هستید؟"}
          linkText={""}
          style={{ direction: "rtl" }}
          buttonText="حذف"
          close={() => setShowRemove()}
          color="red"
          action={() => (props.action ? defAction() : removeItem())}
        />
      ) : (
        <></>
      )}
      {showDesc ? (
        <DataModal
          action={(e) => updateDesc(e)}
          close={() => setShowDesc(0)}
          color="darkblue"
          buttonText="تغییر توضیحات"
          def={data.description}
          title={"تغییر توضیحات"}
        />
      ) : (
        <></>
      )}
    </>
  );
}
export default QuickRow;
